import React from "react";

export const DownArrow = () => (
  <svg
    className="-mr-1 h-5 w-5 text-gray-400"
    viewBox="0 0 20 20"
    fill="currentColor"
  >
    <path
      fillRule="evenodd"
      d="M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06Z"
      clipRule="evenodd"
    />
  </svg>
);

export const ToggleIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M23.6696 15.33C24.1101 15.7707 24.1101 16.4833 23.6696 16.9193L19.9199 20.6698C19.2169 21.3731 17.9982 20.8808 17.9982 19.8728V18.0022H15.2423C15.165 18.0025 15.0884 17.9868 15.0175 17.9562C14.9465 17.9255 14.8826 17.8805 14.8298 17.8241L11.5208 14.2798L14.0189 11.6028L16.4984 14.2517H17.9982V12.3764C17.9982 11.3731 19.2122 10.8762 19.9199 11.5794L23.6696 15.33ZM0.562445 6.75056H4.49956L6.97432 9.40408L9.47251 6.72712L6.16346 3.18284C6.11159 3.12611 6.04864 3.08062 5.97851 3.04917C5.90837 3.01772 5.83254 3.00099 5.75569 3H0.562445C0.2531 3 0 3.25316 0 3.56258V6.18797C0 6.4974 0.2531 6.75056 0.562445 6.75056ZM17.9982 6.75056V8.62584C17.9982 9.6338 19.2169 10.1261 19.9199 9.42284L23.6696 5.67227C24.1101 5.23158 24.1101 4.51897 23.6696 4.08297L19.9199 0.332409C19.2122 -0.375509 17.9982 0.12144 17.9982 1.12472V3H15.2423C15.165 2.99975 15.0884 3.01544 15.0175 3.04609C14.9465 3.07674 14.8826 3.1217 14.8298 3.17815L4.49956 14.2517H0.562445C0.2531 14.2517 0 14.5048 0 14.8143V17.4397C0 17.7491 0.2531 18.0022 0.562445 18.0022H5.75569C5.91036 18.0022 6.06035 17.9366 6.16815 17.8241L16.4984 6.75056H17.9982Z"
      fill="white"
    />
  </svg>
);

export const ToastSuccess = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="12" cy="12" r="10" stroke="green" strokeWidth="2" fill="none" />
    <path
      d="M7 12l3 3 6-6"
      stroke="green"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ToastError = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="12" cy="12" r="10" stroke="red" strokeWidth="2" fill="none" />
    <path
      d="M15 9l-6 6M9 9l6 6"
      stroke="red"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ToastClose = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 5L5 15M5 5l10 10"
      stroke="gray"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const LSIcon = () => (
  <svg
    className="h-4 w-4 text-gray-500"
    viewBox="0 0 20 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 8C9.20938 8 11 6.20937 11 4C11 1.79063 9.20938 0 7 0C4.79063 0 3 1.79063 3 4C3 6.20937 4.79063 8 7 8ZM9.8 9H9.27813C8.58438 9.31875 7.8125 9.5 7 9.5C6.1875 9.5 5.41875 9.31875 4.72188 9H4.2C1.88125 9 0 10.8813 0 13.2V14.5C0 15.3281 0.671875 16 1.5 16H12.5C13.3281 16 14 15.3281 14 14.5V13.2C14 10.8813 12.1188 9 9.8 9ZM19.8938 4.9875L19.025 4.10938C18.8813 3.9625 18.6469 3.9625 18.5 4.10625L15.225 7.35625L13.8031 5.925C13.6594 5.77813 13.425 5.77812 13.2781 5.92188L12.4 6.79375C12.2531 6.9375 12.2531 7.17188 12.3969 7.31875L14.95 9.89062C15.0938 10.0375 15.3281 10.0375 15.475 9.89375L19.8906 5.5125C20.0344 5.36562 20.0375 5.13125 19.8938 4.9875Z"
      fill="#6E6C71"
    />
  </svg>
);

export const CalendarIcon = () => (
  <svg
    width="16"
    height="18"
    viewBox="0 0 16 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.0625 2.25H12.375V0.421875C12.375 0.189844 12.1852 0 11.9531 0H10.5469C10.3148 0 10.125 0.189844 10.125 0.421875V2.25H5.625V0.421875C5.625 0.189844 5.43516 0 5.20312 0H3.79687C3.56484 0 3.375 0.189844 3.375 0.421875V2.25H1.6875C0.755859 2.25 0 3.00586 0 3.9375V16.3125C0 17.2441 0.755859 18 1.6875 18H14.0625C14.9941 18 15.75 17.2441 15.75 16.3125V3.9375C15.75 3.00586 14.9941 2.25 14.0625 2.25ZM13.8516 16.3125H1.89844C1.78242 16.3125 1.6875 16.2176 1.6875 16.1016V5.625H14.0625V16.1016C14.0625 16.2176 13.9676 16.3125 13.8516 16.3125Z"
      fill="#6E6C71"
    />
  </svg>
);

export const HouseIcon = () => (
  <svg
    width="16"
    height="18"
    viewBox="0 0 16 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.5 5.20312V3.79688C4.5 3.56484 4.68984 3.375 4.92187 3.375H6.32812C6.56016 3.375 6.75 3.56484 6.75 3.79688V5.20312C6.75 5.43516 6.56016 5.625 6.32812 5.625H4.92187C4.68984 5.625 4.5 5.43516 4.5 5.20312ZM9.42187 5.625H10.8281C11.0602 5.625 11.25 5.43516 11.25 5.20312V3.79688C11.25 3.56484 11.0602 3.375 10.8281 3.375H9.42187C9.18984 3.375 9 3.56484 9 3.79688V5.20312C9 5.43516 9.18984 5.625 9.42187 5.625ZM4.92187 9H6.32812C6.56016 9 6.75 8.81016 6.75 8.57812V7.17188C6.75 6.93984 6.56016 6.75 6.32812 6.75H4.92187C4.68984 6.75 4.5 6.93984 4.5 7.17188V8.57812C4.5 8.81016 4.68984 9 4.92187 9ZM9.42187 9H10.8281C11.0602 9 11.25 8.81016 11.25 8.57812V7.17188C11.25 6.93984 11.0602 6.75 10.8281 6.75H9.42187C9.18984 6.75 9 6.93984 9 7.17188V8.57812C9 8.81016 9.18984 9 9.42187 9ZM6.75 11.9531V10.5469C6.75 10.3148 6.56016 10.125 6.32812 10.125H4.92187C4.68984 10.125 4.5 10.3148 4.5 10.5469V11.9531C4.5 12.1852 4.68984 12.375 4.92187 12.375H6.32812C6.56016 12.375 6.75 12.1852 6.75 11.9531ZM9.42187 12.375H10.8281C11.0602 12.375 11.25 12.1852 11.25 11.9531V10.5469C11.25 10.3148 11.0602 10.125 10.8281 10.125H9.42187C9.18984 10.125 9 10.3148 9 10.5469V11.9531C9 12.1852 9.18984 12.375 9.42187 12.375ZM15.75 16.7344V18H0V16.7344C0 16.5023 0.189844 16.3125 0.421875 16.3125H1.10742V0.84375C1.10742 0.376172 1.48359 0 1.95117 0H13.7988C14.2664 0 14.6426 0.376172 14.6426 0.84375V16.3125H15.3281C15.5602 16.3125 15.75 16.5023 15.75 16.7344ZM2.79492 16.2773H6.75V13.9219C6.75 13.6898 6.93984 13.5 7.17187 13.5H8.57812C8.81015 13.5 9 13.6898 9 13.9219V16.2773H12.9551V1.72266L2.8125 1.6875L2.79492 16.2773Z"
      fill="#6E6C71"
    />
  </svg>
);

export const LocationIcon = () => (
  <svg
    width="14"
    height="18"
    viewBox="0 0 14 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.05683 17.6362C0.949126 10.2295 0 9.47017 0 6.74934C0 3.02314 3.02314 0 6.74934 0C10.4755 0 13.4987 3.02314 13.4987 6.74934C13.4987 9.47017 12.5496 10.2295 7.44185 17.6362C7.1079 18.1213 6.39078 18.1213 6.05331 17.6362H6.05683ZM6.74934 9.56157C8.30309 9.56157 9.56157 8.3031 9.56157 6.74934C9.56157 5.19559 8.30309 3.93712 6.74934 3.93712C5.19559 3.93712 3.93712 5.19559 3.93712 6.74934C3.93712 8.3031 5.19559 9.56157 6.74934 9.56157Z"
      fill="#6E6C71"
    />
  </svg>
);

export const ApprovalFlagIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11 1V5H5.00001V1M3.00001 1H13L17.0001 5V15C17.0001 15.5304 16.7893 16.0391 16.4143 16.4142C16.0392 16.7893 15.5305 17 15.0001 17H3.00001C2.46957 17 1.96086 16.7893 1.58579 16.4142C1.21071 16.0391 1 15.5304 1 15V3C1 2.46957 1.21071 1.96086 1.58579 1.58579C1.96086 1.21071 2.46957 1 3.00001 1ZM7.00002 11C7.00002 11.5304 7.21074 12.0391 7.58581 12.4142C7.96089 12.7893 8.46959 13 9.00003 13C9.53046 13 10.0392 12.7893 10.4142 12.4142C10.7893 12.0391 11 11.5304 11 11C11 10.4696 10.7893 9.96086 10.4142 9.58579C10.0392 9.21071 9.53046 9 9.00003 9C8.46959 9 7.96089 9.21071 7.58581 9.58579C7.21074 9.96086 7.00002 10.4696 7.00002 11Z"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DropdownToggleIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                    <path d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z" />
                  </svg>
)

export const ClipBoardIcon = () => (
    <svg
            xmlns="http://www.w3.org/2000/svg"
            className="w-3/5 h-3/5 text-gray-600"
            viewBox="0 0 10.5 12"
            fill="currentColor">
            <path
              d="M7.5 10.5V11.4375C7.5 11.7492 7.24922 12 6.9375 12H0.5625C0.250781 12 0 11.7492 0 11.4375V2.8125C0 2.50078 0.250781 2.25 0.5625 2.25H2.25V9.1875C2.25 9.91172 2.83828 10.5 3.5625 10.5H7.5ZM7.5 2.4375V0H3.5625C3.25078 0 3 0.250781 3 0.5625V9.1875C3 9.49922 3.25078 9.75 3.5625 9.75H9.9375C10.2492 9.75 10.5 9.49922 10.5 9.1875V3H8.0625C7.75313 3 7.5 2.74688 7.5 2.4375ZM10.3359 1.71094L8.78906 0.164062C8.68387 0.0592306 8.54148 0.000254388 8.39297 0L8.25 0V2.25H10.5V2.10703C10.5002 2.03309 10.4858 1.95985 10.4576 1.89148C10.4295 1.82311 10.3881 1.76097 10.3359 1.70859V1.71094Z"
              fill="currentColor"
            />
          </svg>
)

/**
 * Magnifier icon for search / apply-filter buttons (Payment Platform headers).
 *
 * @param {{size?: number, color?: string}} props - Pixel size and stroke colour.
 * @returns {JSX.Element}
 */
export const SearchIcon = ({ size = 16, color = "white" }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9 17a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM19 19l-4.35-4.35"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

/**
 * Circular-arrows refresh / reset icon (Payment Platform headers).
 *
 * @param {{size?: number, color?: string}} props - Pixel size and stroke colour.
 * @returns {JSX.Element}
 */
// Eta-Dark Grey (Figma "3: Text/Eta- Dark Grey"). The stroke colour the Payment
// Platform header buttons pass to RefreshIcon so the arrow is visible on the light
// #d1cfd4 refresh button. RefreshIcon still defaults to white, so any other
// importer (e.g. a purple button) renders white unless it opts into this token.
export const ICON_GREY = "#6E6C71";

export const RefreshIcon = ({ size = 16, color = "white" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4 4v5h5M20 20v-5h-5M4.5 9a8 8 0 0 1 14.5-3.5M19.5 15a8 8 0 0 1-14.5 3.5"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

/**
 * Download-tray icon for dated Statement buttons (Payment Platform headers).
 *
 * @param {{size?: number, color?: string}} props - Pixel size and stroke colour.
 * @returns {JSX.Element}
 */
export const DownloadIcon = ({ size = 14, color = "white" }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10 3v10m0 0-4-4m4 4 4-4M4 17h12"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)